// import {Tooltip2} from "@blueprintjs/popover2";
import {Tooltip as TooltipOld} from "@blueprintjs/core";

const Tooltip = (props) => {
    const {content, position, children} = props;
    return (
        <TooltipOld
            content={content}
            placement={position}
        >
            {children}
        </TooltipOld>
    );
};

export default Tooltip;